module.exports = __webpack_public_path__ + "img/midland-trade-logo-white.99a98d96.png";